//IMPORTING COLORS
import {
  WHITE,
  TEXT_COLOR,
  PRIMARY_BTN_KA,
  TITLE_COLOR_KA,
  SUB_TITLE_COLOR_KA,
  ICON_COLOR_KA,
  FADE_BG_KA,
  BOX_SHADOW_KA,
  LIGHT_BG_KA,
  FOOTER_BG_KA,
} from "../../utils/colors";

//IMPORTING FONT
import {
  TITLE_SIZE,
  SUB_TITLE_SIZE,
  TEXT_SIZE,
  SUB_TEXT_SIZE,
} from "../../utils/fonts";

//IMPORT NUMBERS
import { WHATS_APP_LINK } from "../../utils/phoneNumbers";

import { useEffect } from "react";
import DynamicTitle from "../../components/DynamicTitle";
import BannerSection from "../../components/BannerSection";
import BannerAbout from "../../components/BannerAbout";
import JoinUsCall from "../../components/JoinUsCall";
import LocationCall from "../../components/LocationCall";
import FooterBar from "../../components/FooterBar";
import ComercialCards from "../../components/ComercialCards";
import ClientAreaCall from "../../components/ClientAreaCall";
import RedeVantagens from "../../components/RedeVantagens";
import { LuHandshake } from "react-icons/lu";
import { LuHandHeart } from "react-icons/lu";
import LogoKA from "../../assets/logo/logo-KA.png";
import AppDownload from "../../components/AppDownload";
import FormSection from "../../components/FormSection";
import RecentPosts from "../../components/RecentPostsCall";
import PartnerAreaCall from "../../components/PartnerAreaCall";
import KA from "../../assets/images/Ka.webp";
import KAMob from "../../assets/images/ka-mob.webp";
import "./Assistencial.css";

export default function Assistencial() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="Assistencial">
      <DynamicTitle
        pageTitle="Grupo Krause - Plano Assistencial Krause"
        pageMeta="Plano Assistencial Krause"
        pageContent="O Plano Assistencial Krause não possui restrições de parentesco, é ideal para você incluir quem quiser, inclusive seu pet. Garanta mais proteção e vantagens exclusivas para quem você ama."
      />
      <BannerSection
        white={WHITE}
        fadeBG={FADE_BG_KA}
        iconTitle={
          <LuHandHeart
            style={{ color: WHITE }}
            className="banner-section-icon"
          />
        }
        bannerTitle={"PLANO ASSISTENCIAL"}
        bannerTitleSize={TITLE_SIZE}
        bannerSubTitle={"Seus laços de vida unidos em um único plano."}
        bannerSubTitleSize={SUB_TITLE_SIZE}
        bannerBG={KA}
        bannerBGmobile={KAMob}
      />
      <BannerAbout
        companyBrand={LogoKA}
        firstText={`Conheça a Rede de Vantagens e o Plano Assistencial Grupo Krause. Sem
              restrições de parentesco, é ideal para você incluir quem quiser,
              inclusive seu pet. Garanta mais proteção e vantagens exclusivas
              para quem você ama.`}
        secondText={`Um plano de assistência funeral com mais de 300 parceiros da Rede de Vantagens e benefícios exclusivos. O Grupo
              Krause é uma empresa com mais de 100 anos de atuação na região do Vale
              dos Sinos. Além de garantir o amparo nos momentos mais difíceis, o
              plano oferece milhares de vantagens para você e seus dependentes
              sem pagar nada mais por isso.`}
        textColor={TEXT_COLOR}
        textSize={TEXT_SIZE}
      />
      <ComercialCards
        white={WHITE}
        iconColor={ICON_COLOR_KA}
        comercialIcon={LogoKA}
        titleColor={TITLE_COLOR_KA}
        subTitleColor={SUB_TITLE_COLOR_KA}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        subTextSize={SUB_TEXT_SIZE}
        shadowColor={BOX_SHADOW_KA}
        btnColor={PRIMARY_BTN_KA}
        textTop={220}
        whatsAppNumber={WHATS_APP_LINK}
      />
      <RedeVantagens
        white={WHITE}
        iconColor={ICON_COLOR_KA}
        titleColor={TITLE_COLOR_KA}
        subTitleColor={SUB_TITLE_COLOR_KA}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        subTitleSize={SUB_TITLE_SIZE}
        btnColor={PRIMARY_BTN_KA}
      />
      <FormSection
        titleIcon={
          <LuHandshake
            style={{ color: ICON_COLOR_KA }}
            className="form-first-col-icon"
          />
        }
        titleContent={
          <h2 style={{ color: TITLE_COLOR_KA, fontSize: TITLE_SIZE }}>
            FAÇA SEU PLANO
          </h2>
        }
        subTitleContent={
          <h3 style={{ color: SUB_TITLE_COLOR_KA, fontSize: SUB_TITLE_SIZE }}>
            Fazer o Plano Assistencial Grupo Krause é fazer mais pela sua
            família.
          </h3>
        }
        textContent={
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            Preencha agora mesmo os campos do formulário e seja um cliente Grupo
            Krause! Um consultor irá entrar em contato com você o mais breve
            possível.
          </p>
        }
        formSrc="https://cdn.bitrix24.com.br/b18068281/crm/form/loader_169.js"
        formData="inline/169/d7act9"
      />
      <ClientAreaCall
        white={WHITE}
        iconColor={ICON_COLOR_KA}
        titleColor={TITLE_COLOR_KA}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        btnColor={PRIMARY_BTN_KA}
        autoCarosel={false}
      />
      <AppDownload
        iconColor={ICON_COLOR_KA}
        titleColor={TITLE_COLOR_KA}
        subTitleColor={SUB_TITLE_COLOR_KA}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        subTitleSize={SUB_TITLE_SIZE}
        lightBG={LIGHT_BG_KA}
      />
      <PartnerAreaCall
        white={WHITE}
        iconColor={ICON_COLOR_KA}
        titleColor={TITLE_COLOR_KA}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        btnColor={PRIMARY_BTN_KA}
      />
      <RecentPosts
        white={WHITE}
        iconColor={ICON_COLOR_KA}
        titleColor={TITLE_COLOR_KA}
        textColor={TEXT_COLOR}
        btnColor={PRIMARY_BTN_KA}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        subTitleSize={SUB_TITLE_SIZE}
        subTextSize={SUB_TEXT_SIZE}
      />
      <LocationCall
        white={WHITE}
        iconColor={ICON_COLOR_KA}
        titleColor={TITLE_COLOR_KA}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        fadeBG={FADE_BG_KA}
      />
      <JoinUsCall
        white={WHITE}
        iconColor={ICON_COLOR_KA}
        titleColor={TITLE_COLOR_KA}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        fadeBG={FADE_BG_KA}
        circleBG={LIGHT_BG_KA}
        btnColor={PRIMARY_BTN_KA}
      />
      <FooterBar titleColor={TITLE_COLOR_KA} footerBarBG={FOOTER_BG_KA} />
    </div>
  );
}
